/**
 * Same-origin lobby mounting for game-window v3 (`/game-window-play`).
 * `/game-play` is launcher v2 only (casino-game-launcher via casino-next when v3 is off).
 * Root-mounted `gw.*` behaviour is unchanged.
 */

/** Game-window v3 lobby mount (same-domain experiment + mock harness). */
export const SAME_ORIGIN_GAME_WINDOW_PLAY_PATH = '/game-window-play';

export const SAME_ORIGIN_GAME_CLIENT_PATH = '/game-client';

const isPathUnderMount = (pathname: string, mountPath: string): boolean =>
  pathname === mountPath || pathname.startsWith(`${mountPath}/`);

/** Lobby mount path for game-window (`/game-window-play`), or null on `gw.*`. */
export const resolveSameOriginMountPath = (
  pathname: string | undefined | null,
): string | null => {
  if (!pathname) {
    return null;
  }

  if (isPathUnderMount(pathname, SAME_ORIGIN_GAME_WINDOW_PLAY_PATH)) {
    return SAME_ORIGIN_GAME_WINDOW_PLAY_PATH;
  }

  return null;
};

/** Base public path when lobby-mounted, else `null` (root / `gw.*`). */
export const resolveSameOriginPublicPath = (
  pathname: string | undefined | null,
): string | null => {
  const mountPath = resolveSameOriginMountPath(pathname);
  return mountPath ? `${mountPath}/` : null;
};

/** True when served from a lobby same-origin mount (`/game-window-play`). */
export const isSameOriginMountPath = (
  pathname: string | undefined | null,
): boolean => resolveSameOriginMountPath(pathname) !== null;

/** React Router basename for lobby mounts; empty string on `gw.*`. */
export const resolveRouterBasename = (
  pathname: string | undefined | null,
): string => resolveSameOriginMountPath(pathname) ?? '';
